import { Box, Card, CardContent, Typography } from "@mui/material";
import { LitigationFunnelMatter } from "../../../api/models/LitigationFunnelMatter";
import { useState } from "react";
import { MatterDialog } from "./MatterDialog";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PersonIcon from "@mui/icons-material/Person";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

interface Props {
  matter: LitigationFunnelMatter;
}

export const MatterCard = ({ matter }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Card
        onClick={() => setOpen(true)}
        elevation={0}
        sx={{
          borderRadius: 1.5,
          border: "1px solid",
          borderColor: "divider",
          marginTop: 1,
          cursor: "pointer",
          bgcolor: "#fafbfd",
          transition: "background-color 120ms ease, border-color 120ms ease",
          "&:hover": {
            bgcolor: "background.paper",
            borderColor: "rgba(27, 30, 51, 0.18)",
          },
        }}
      >
        <CardContent sx={{ padding: 1, paddingBottom: "8px !important" }}>
          <Typography
            variant="subtitle2"
            sx={{
              textWrap: "auto",
              wordWrap: "break-word",
              wordBreak: "break-all",
              fontWeight: 600,
              fontSize: "0.8125rem",
            }}
          >
            {matter.matter.display_number}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 0.25,
              mt: 0.5,
            }}
          >
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{
                textWrap: "auto",
                wordBreak: "break-all",
                wordWrap: "break-word",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <AssignmentIcon sx={{ fontSize: "0.75rem", mr: 0.5 }} />
              {matter.task.name}
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}>
              <Typography variant="caption" color="text.secondary" sx={{ textWrap: "auto" }}>
                <PersonIcon sx={{ fontSize: "0.75rem", mr: 0.5 }} />
                {matter.task.assignee.name}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                <CalendarTodayIcon sx={{ fontSize: "0.75rem", mr: 0.5 }} />
                {new Date(matter.task.due_at).toLocaleDateString("en-US")}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>

      {open && (
        <MatterDialog
          open={open}
          onClose={() => setOpen(false)}
          matterId={matter.matter.id}
        />
      )}
    </>
  );
};
